export const EDIT_SERVICE_PLAN_ADD_SERVICES = 'AdditionalServices'
export const EDIT_SERVICE_PLAN_EXTEND_SERVICES = 'ExtendServices'
export const EDIT_SERVICE_PLAN_ADD_SERVICE_PARTNERS = 'AddServicePartners'
export const EDIT_SERVICE_PLAN_EARLY_TERMINATION = 'EarlyTermination'

export const MAX_NUMBER_OF_SERVICE_PARTNERS = 5
